<template lang="pug">
  .container.grid-lg.py-2
    .no-print
      form-filter(@submit="onFilter" :auto-filter='autoFilter' :default-query='q' filter-key='doc-implantados-filters')

    load-manager(:status='status')
      list-manager(:status='status', :count='list.length')
        table.table.table-striped.table-sm
          thead
            tr
              th {{ "doc.numero" | tModel }}/{{ "doc.ano" | tModel }}
              th {{ "doc.cadastro" | tModel }}
              th {{ "doc.modelo" | tModel }}
              th {{ "doc.comentario_situacao" | tModel }}
              th {{ "doc.fiscal" | tModel }}
              th {{ "doc.created_at" | tModel }}
              th {{ "doc.ciencia_em" | tModel }}
              th {{ "doc.debito_vence_em" | tModel }}
              th.text-right Área
              th.text-right {{ "doc.valor_total" | tModel }}
              th.actions-col.no-print
          tbody
            tr(v-for="doc in list")
              td {{ doc.numero }}/{{ doc.ano }}
              td
                small
                  span.abbr {{ doc.cadastro | enums('cadastro.tipo') }}
                span  {{ doc.cadastro.numero }}
              td {{ doc.modelo ? doc.modelo.descricao : '-' }}
              td {{ doc.comentario_situacao ? doc.comentario_situacao.descricao : '-' }}
              td {{ doc.fiscal ? doc.fiscal.nome : "-" }}
              td {{ doc.created_at | date }}
              td {{ doc.ciencia_em | date }}
              td {{ doc.debito_vence_em | date('DD/MM/YYYY') }}
              td.text-right {{ doc.area | currency }}
              td.text-right {{ doc.valor_total | currency }}
              td.actions-col.no-print
                router-link.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                  data-tooltip="Exibir"
                  :to="{name: 'fiscalizacao.docs.show', params: {id: doc.id}}"
                )
                  i.fa.fa-eye
        .my-2.text-right(v-if='pages > 1')
          btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
</template>

<script>
import { vuexDefaultMapping } from '@/mixins/list'
import FormFilter from '../docs/components/Filter'

export default {
  vuex: {
    'fiscalizacao/docImplantados': vuexDefaultMapping,
  },

  components: { FormFilter },

  data() {
    return { q: { id_order_by: 'desc' } }
  },

  methods: {
    onFilter(q = {}) {
      this.q = { ...q }
      this.setQuery({ ...q })
      this.setPage(1)
      this.fetchList()
    },
  },

  computed: {
    autoFilter() {
      return !this.list || this.list.length === 0
    },
  },

  created() {
    this.q = { ...this.q, ...this.query }
  },
}
</script>
